<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" label-width="180px">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'hirecar',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/expatriate` },
        { name: "雇佣车辆", path: `/vehicle/expatriate` },
        { name: "查看车辆" },
      ],
      viewMode: true,
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
        },
        {
          label: "承运人",
          keyName: "pname",
          err: "请选择承运人",
          type: "select",
        },
        {
          label: "司机",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
        },
        {
          label: "联系方式",
          keyName: "phone",
          err: "请填写联系方式",
          type: "text",
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-input {
      width: 200px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
